import React from 'react'
import {colors} from "../../utils/styles"

const alertInfoStyle = {
  backgroundColor: colors.white,
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
  zIndex: 402,
  position: 'fixed',
  left: '50%',
  top: 310,
  marginLeft: '-226px',
  opacity: '1.0',
  width: 500
}

const alertInfoStyleMini = {
  backgroundColor: colors.white,
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
  zIndex: 402,
  width: 500,
  margin: 'auto'
}

const titleStyle = {
  fontWeight: 600,
  fontSize: 18,
  padding: 20
}

const bodyStyle = {
  fontSize: 16,
  color: colors.offBlack,
  paddingLeft: 20,
  paddingRight: 20,
  wordBreak: 'break-word'
}

const buttonContainerStyle = {
  padding: 20,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end'
}

const okButtonStyle = {
  marginLeft: 20,
  padding: '10px 25px',
  height: 40,
  boxSizing: 'border-box'
}
const cancelButtonStyle = {padding: '10px 20px'}

export default class NotifyDialog extends React.Component {

  handleOk() {
    if (!this.clickedOk) {
      // intentionally don't use setState to change clickedOk to true to reduce chances
      // user can get a 2nd click in
      this.clickedOk = true
      this.props.okCallback()
      this.setState({})
    }
  }

  render() {
    const {
      titleText,
      bodyText,
      cancelCallback,
      showOk,
      showCancel,
      dialogInsideModal,
      cancelText,
      okText
    } = this.props
    const showOkButton = ((showOk === undefined) || showOk) && !this.clickedOk
    const notifyModalEffectClass = dialogInsideModal ? "waiting-modal-effect-inside-modal"
        : "waiting-modal-effect"
    const modalAlertInfoStyle = dialogInsideModal ? alertInfoStyleMini : alertInfoStyle

    return (<div className={notifyModalEffectClass}>
          <div style={modalAlertInfoStyle} className={"notify-dialog"}>
            <div style={titleStyle}>
              {titleText}
            </div>
            <div style={bodyStyle}>
              {bodyText}
            </div>
            <div style={buttonContainerStyle}>
              {showCancel && <button
                  className="notify-btn notify-btn-cancel"
                  style={cancelButtonStyle}
                  onClick={cancelCallback}>{cancelText ? cancelText : "CANCEL"}</button>}
              {showOkButton && <button
                  className="notify-btn notify-btn-ok"
                  style={okButtonStyle}
                  onClick={this.handleOk.bind(this)}>{okText ? okText : "OK"}</button>}
              {this.clickedOk && <img alt="..." src="images/loading2.gif" style={okButtonStyle}/>}
            </div>
          </div>
        </div>
    )
  }
}